<div>
  <mat-card>
    <mat-card-content>
      <mat-form-field>
        <mat-label>Product</mat-label>
        <mat-select [(value)]="selectedProduct" (selectionChange)="productChange($event)">
          <mat-option *ngFor="let product of products" [value]="product">
            <div fxLayout="row" fxLayoutAlign="start center">
              <div class="m-r-10 chart-select-color" [style.background-color]="product.productColor"></div><div>{{product.product}}</div>
            </div>
          </mat-option>
        </mat-select>
        
      </mat-form-field>
    </mat-card-content>
  </mat-card>
</div>
<div class="analytics" fxLayout="row" fxLayout.lt-md="column">
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <chart
      title="Render Time"
      [subtitle]="true"
      [type]="'bar'"
      [data]="renderChartData"
      [labels]="renderChartLabels"
      [colors]="renderChartColors"
      [loading]="renderChartLoading"
      (chartClick)="handleChartClick($event)"
      [labelFormatter]="labelFormatter"
      [isDarkMode]="isDarkMode">
      <span [style.color]="selectedProduct?.productColor">{{ selectedProduct?.product }}</span> estimated render time is <span [style.color]="selectedProduct?.productColor">{{ getEstimatedRenderTime() }}</span>
    </chart>
  </div>
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <chart
      title="Views"
      [subtitle]="true"
      [type]="'bar'"
      [data]="viewsChartData"
      [labels]="viewsChartLabels"
      [colors]="viewsChartColors"
      [loading]="viewsChartLoading"
      (chartClick)="handleChartClick($event)"
      [labelFormatter]="labelFormatter"
      [isDarkMode]="isDarkMode">
      Most popular homes in the past 24 hours
    </chart>
  </div>
</div>
<div class="view-container" fxLayout="row" fxLayout.lt-md="column">
  <div class="cached-homes" fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <div *ngIf="cachedHomesLoading">
        <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
      </div>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <div class="faux-label">Your Homes</div>
          <button *ngIf="isAdmin"
            [@cardAnimator]="animateAddHome"
            (@cardAnimator.done)="resetAddHomeAnimationState()" 
            [matTooltip]="(homeConfigs?.length > 0 ? 'Add Home' : 'Add Home to get started!')"
            mat-flat-button color="accent"
            (click)="onClickAddHome()">
            <mat-icon>add</mat-icon> Add Home
          </button>
        </div>
        <mat-card *ngIf="homeConfigs?.length > 0" class="contrast" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <mat-form-field>
              <input matInput type="text"
                [formControl]="searchField"
                (keyup)="doFilter($event.target.value)"
                (keyup.esc)="$event.target.value=''; doFilter('')"
                placeholder="Filter homes by name">
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <ng-container *ngFor="let item of filteredHomeConfigs; let i = index">
          <mat-card *ngIf="expandedHomesList || i < 12" class="contrast card-link" [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="navigateToIfc(item?.name)">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
              <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
                <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="capitalizeFirstLetter(item?.name) | highlight: searchField.value"></strong>
              </div>
              <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </ng-container>
        <mat-card *ngIf="homeConfigs?.length > 0" class="contrast card-link banner-info" [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="toggleExpandedHomesList()">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="100" fxLayoutAlign="center center" fxLayout="row">
              <strong *ngIf="!expandedHomesList" class="text-center" [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_more</mat-icon></strong>
              <strong *ngIf="expandedHomesList" class="text-center" [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_less</mat-icon></strong>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-card-content> 
    </mat-card>
  </div>
  <div class="ifc-files-feed" fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <ifc-file-list 
      [loading]="ifcFilesLoading"
      [homeIfcFiles]="homeIfcFiles"
      [homeIfcFileErrors]="homeIfcFileErrors">
    </ifc-file-list>
  </div>
</div>